import React from 'react';
import { StyledAvatar, StyledImage } from './index.styles.js';
import { Icon } from '../icon/index.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import {} from '../icon/icon-names.generated.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const Avatar = ({ size, onClick, label, variant, selected, className, disabled, margin, image, icon, as = 'button', ...rest }) => {
    const iconSize = size === 'md' ? 'l' : size === 'sm' ? 's' : 'xs';
    const a11yProps = pickA11yProps(rest);
    const dataProps = pickDataProps(rest);
    const getContent = () => {
        if (variant === 'logged-out') {
            return React.createElement(Icon, { size: iconSize, name: "user" });
        }
        if (image && !icon) {
            return React.createElement(StyledImage, { src: image.src, alt: image.alt, role: image.role });
        }
        if (icon && !image) {
            return React.createElement(Icon, { size: iconSize, name: icon });
        }
        return label;
    };
    return (React.createElement(StyledAvatar, { icon: icon, "$selected": selected, size: size, className: className, disabled: disabled, onClick: onClick, variant: variant, margin: margin, image: image, as: as, ...a11yProps, ...dataProps }, getContent()));
};
//# sourceMappingURL=index.js.map